export default function SectionHead({
  eyebrow,
  title,
  desc,
  align = "left",
}: {
  eyebrow?: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
}) {
  return (
    <div className={`mb-8 ${align === "center" ? "text-center" : ""}`}>
      {eyebrow && (
        <p className="mb-2 flex items-center gap-2 text-xs font-bold tracking-widest text-primary-500 uppercase">
          {align === "center" && <span className="h-px w-6 bg-primary-400" />}
          {eyebrow}
          {align === "left" && <span className="h-px w-6 bg-primary-400" />}
        </p>
      )}
      <h2 className="font-heading text-2xl text-foreground-950 md:text-3xl">{title}</h2>
      {desc && <p className="mt-2 text-sm text-foreground-600 md:text-base">{desc}</p>}
    </div>
  );
}